import { Importance, PairResult, ViewResultResponse } from '../types/Result';
import { UserRole } from '../types/User';

export enum ResultSections {
    TOP_PRIORITY = 1,
    IMPORTANT_TO_BOTH,
    IMPORTANT_TO_PATIENT,
    IMPORTANT_TO_CAREGIVER,
    NOT_IMPORTANT,
    NON_RANKED,
}

export type AdaptedPairResults = {
    [key in ResultSections]: PairResult[];
}

//adapting survey results into categories for display
export const adaptResultsToSections = (surveyResults: ViewResultResponse) => {
    //questions to sort
    const rankedQuestions = surveyResults.rankedQuestions;
    //questions patient and caregiver both selected as Important or Very Important
    const importantToBoth: PairResult[] = [
        ...rankedQuestions[Importance.VERY_IMPORTANT][Importance.VERY_IMPORTANT],
        ...rankedQuestions[Importance.VERY_IMPORTANT][Importance.IMPORTANT],
        ...rankedQuestions[Importance.IMPORTANT][Importance.VERY_IMPORTANT],
        ...rankedQuestions[Importance.IMPORTANT][Importance.IMPORTANT],
    ];
    //questions patient selected as Important or Very Important that caregiver did not select
    const importantToPatient = [
        ...rankedQuestions[Importance.VERY_IMPORTANT][Importance.NOT_IMPORTANT],
        ...rankedQuestions[Importance.IMPORTANT][Importance.NOT_IMPORTANT],
    ];
    //questions caregiver selected as Important or Very Important that patient did not select
    const importantToCaregiver = [
        ...rankedQuestions[Importance.NOT_IMPORTANT][Importance.VERY_IMPORTANT],
        ...rankedQuestions[Importance.NOT_IMPORTANT][Importance.IMPORTANT],
    ];
    //questions neither patient nor caregiver selected as Important or Very Important
    const notImportant = [
        ...rankedQuestions[Importance.NOT_IMPORTANT][Importance.NOT_IMPORTANT]
    ];

    //filter out blank nonRanked answers
    const filteredNonRanked = surveyResults.nonRankedQuestions.filter(result => {
        return result.answer.hasOwnProperty(UserRole.PATIENT) ?
            !!result.answer[UserRole.PATIENT] : !!result.answer[UserRole.CARE_PARTNER];
    })

    const adaptedSurveyResults = {
        [ResultSections.TOP_PRIORITY]: surveyResults.topPriority,
        [ResultSections.IMPORTANT_TO_BOTH]: importantToBoth,
        [ResultSections.IMPORTANT_TO_PATIENT]: importantToPatient,
        [ResultSections.IMPORTANT_TO_CAREGIVER]: importantToCaregiver,
        [ResultSections.NOT_IMPORTANT]: notImportant,
        [ResultSections.NON_RANKED]: filteredNonRanked,
    }

    return adaptedSurveyResults;
}